import api from "./api";
import { parsePaginatedList } from "../utils/pagination";

export interface Recharge {
  id: string;
  cardHolderId: string;
  amount: number;
  status: "pending" | "completed" | "failed" | "cancelled";
  paymentMethod: string;
  transactionId?: string;
  notes?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
  cardHolder?: {
    id: string;
    holderName: string;
    phone?: string;
    email?: string;
  };
  branch?: {
    id: string;
    name: string;
  };
  nfcCard?: {
    id: string;
    displayNumber: string;
    balance: number;
  };
  newBalance?: number;
  creator?: {
    id: string;
    name: string;
    email?: string;
  };
  transaction?: {
    id: string;
    amount: number;
    balanceBefore: number;
    balanceAfter: number;
  };
}

export interface CreateRechargeData {
  cardHolderId?: string;
  nfcCardId?: string;
  amount: number;
  paymentMethod: string;
  notes?: string;
}

export interface UpdateRechargeData {
  amount?: number;
  status?: "pending" | "completed" | "failed" | "cancelled";
  notes?: string;
}

const rechargeAPI = {
  directRecharge: async (
    cardNumber: string,
    amount: number,
    paymentMethod: string = "cash"
  ) => {
    const response = await api.post("/recharges/direct-recharge", {
      cardNumber,
      amount,
      paymentMethod,
    });
    return response.data.data;
  },

  getRecharges: async (params?: {
    pageNo?: number;
    pageSize?: number;
    cardHolderId?: string;
    branchId?: string;
    status?: string;
    paymentMethod?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: "ASC" | "DESC";
  }): Promise<{ data: Recharge[]; total: number }> => {
    const response = await api.get("/recharges", { params });
    const { data, total } = parsePaginatedList<Recharge>(response.data.data);
    return { data, total };
  },

  getRechargeById: async (id: string): Promise<Recharge> => {
    const response = await api.get(`/recharges/${id}`);
    return response.data.data;
  },

  createRecharge: async (data: CreateRechargeData): Promise<Recharge> => {
    const response = await api.post("/recharges", data);
    return response.data.data;
  },

  completeRecharge: async (
    id: string,
    nfcCardId?: string
  ): Promise<Recharge> => {
    const response = await api.put(`/recharges/${id}/status`, {
      status: "completed",
      ...(nfcCardId ? { nfcCardId } : {}),
    });
    return response.data.data;
  },

  updateRecharge: async (
    id: string,
    data: UpdateRechargeData
  ): Promise<Recharge> => {
    const response = await api.put(`/recharges/${id}/status`, data);
    return response.data.data;
  },
};

export default rechargeAPI;
